module.exports = __webpack_public_path__ + "img/team.e6122159.png";